export enum DocumentReviewPeriodEnum {
    None = 0,
    Months6 = 1,
    Months12 = 2,
    Months18 = 3,
    Months24 = 4,
    Months36 = 5
}

const getPeriod = (val: DocumentReviewPeriodEnum | string | undefined) => {
    let period: DocumentReviewPeriodEnum = DocumentReviewPeriodEnum.None;

    if (typeof (val) === 'number') {
        period = val;
    }
    if (typeof (val) === 'string') {
        period = parseInt(val);
    }
    return period;
}

export const getMonths = (val: DocumentReviewPeriodEnum | string | undefined) => {
    const period = getPeriod(val);

    switch (period) {
        case DocumentReviewPeriodEnum.Months6:
            return 6;
        case DocumentReviewPeriodEnum.Months12:
            return 12;
        case DocumentReviewPeriodEnum.Months18:
            return 18;
        case DocumentReviewPeriodEnum.Months24:
            return 24
        case DocumentReviewPeriodEnum.Months36:
            return 36
    }

    return 0;
}

export const documentReviewPeriodDisplay = (val: DocumentReviewPeriodEnum | string | undefined) => {
    const period = getPeriod(val);

    if (period === DocumentReviewPeriodEnum.None) {
        return "None";
    }

    return `${getMonths(period)} months`;
}
